import { Tooltip } from 'react-tooltip';

export const renderPagination = (
	uniqueSites,
	itemsPerPage,
	currentPage,
	totalPages,
	setCurrentPage,
	getPageNumbers
) => {
	return (
		<>
			{uniqueSites > itemsPerPage && (
				<div className="d-flex flex-column">
					<div className="d-flex flex-column">
						<nav aria-label="Page navigation example">
							<ul className="pagination custom-pagination my-0 py-0">
								<li
									className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}
								>
									<button
										className="page-link"
										onClick={() => handlePageChange(1, setCurrentPage)}
										disabled={currentPage === 1}
									>
										<i className="fa-solid fa-angles-left"></i>
									</button>
								</li>
								<li
									className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}
								>
									<button
										className="page-link"
										onClick={() => handlePageChange(currentPage - 1, setCurrentPage)}
										disabled={currentPage === 1}
									>
										<i className="fa-solid fa-chevron-left"></i>
									</button>
								</li>
								{getPageNumbers(currentPage, totalPages).map((page) => (
									<li
										key={page}
										className={`page-item ${
											currentPage === page ? 'active' : ''
										}`}
									>
										<button
											className="page-link bigger"
											onClick={() => handlePageChange(page, setCurrentPage)}
										>
											{page}
										</button>
									</li>
								))}
								<li
									className={`page-item ${
										currentPage === totalPages ? 'disabled' : ''
									}`}
								>
									<button
										className="page-link"
										onClick={() => handlePageChange(currentPage + 1, setCurrentPage)}
										disabled={currentPage === totalPages}
									>
										<i className="fa-solid fa-chevron-right"></i>
									</button>
								</li>
								<li
									className={`page-item ${
										currentPage === totalPages ? 'disabled' : ''
									}`}
								>
									<button
										className="page-link"
										onClick={() => handlePageChange(totalPages, setCurrentPage)}
										disabled={currentPage === totalPages}
									>
										<i className="fa-solid fa-angles-right"></i>
									</button>
								</li>
							</ul>
						</nav>

						<div className="d-flex justify-content-center align-items-center pt-1">
							<input
								id="upload-page-current-page"
								className="form-control text-center me-2"
								style={{ width: '70px' }}
								type="number"
								min={1}
								max={totalPages}
								value={currentPage}
								onChange={(e) => {
									const value = e.target.value;
									if (value.trim() !== '' && value <= totalPages) {
										setCurrentPage(parseInt(value));
									}
								}}
							></input>
							<p className="text-center py-0 my-0">/{totalPages} pages</p>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export const renderToggleFill = (setToggleFill, noPostQCData) => {
	if (noPostQCData) return;

	return (
		<>
			<div className="form-check form-switch ms-3 mt-2">
				<input
					className="form-check-input"
					data-tooltip-id="toggleFillTT"
					type="checkbox"
					id="flexSwitchCheckDefault1"
					onChange={(e) => setToggleFill((prevState) => !prevState)}
				></input>
				<label className="form-check-label" for="flexSwitchCheckDefault1">
					View captures where <span className="fw-bold">fill = 1</span>
				</label>
			</div>{' '}
			<Tooltip id="toggleFillTT" place="bottom" effect="solid">
				Captures where fill=1 are hidden by default
			</Tooltip>
		</>
	);
};

const handlePageChange = (pageNumber, setCurrentPage) => {
	setCurrentPage(pageNumber);
};
